import React from 'react';
import { classNames } from 'primereact/utils';

export const resolveGroupedVariant = ({ variant, classNameProps }) => {
  if (variant) return variant;
  if (classNameProps) return 'primary';
  return 'default';
};

export const GroupedAddon = ({
  title,
  variant,
  classNameProps,
  wide = false,
  className,
}) => {
  const resolved = resolveGroupedVariant({ variant, classNameProps });

  return (
    <span
      className={classNames(
        'p-inputgroup-addon cm-grouped-addon',
        resolved === 'primary' && 'cm-grouped-addon--primary',
        wide && 'cm-grouped-addon--wide',
        className
      )}
    >
      <span className="cm-grouped-addon__text">{title}</span>
    </span>
  );
};
